import type { PlayerLogTypeCount } from '@/composables/api/useLocationZonePlayerInspectorApi';

/**
 * The types the picker offers: what the server saw, plus anything already
 * selected that it didn't.
 *
 * The server reports types from the window it scanned, so narrowing the time
 * range can drop a type out of the list while it is still selected. Without
 * this, the option would vanish from the picker while the filter kept applying
 * — a filter you cannot see and cannot undo. A type in that state shows a count
 * of zero, which is the truth: none in this window.
 */
export function playerLogTypeOptions(
  availableTypes: PlayerLogTypeCount[],
  selectedTypes: string[],
): PlayerLogTypeCount[] {
  const offered = new Map(availableTypes.map((entry) => [entry.type, entry]));
  for (const type of selectedTypes) {
    if (!offered.has(type)) {
      offered.set(type, { type, count: 0 });
    }
  }
  return [...offered.values()];
}
